// extracted by mini-css-extract-plugin
export default {"container":"Widget__container___VAJr9","title":"Widget__title___wA1KE"};